<template>
  <base-modal>
    <template slot="default" slot-scope="{ is_button_loading }">
      <div
        v-for="(row, index) in rows"
        :key="index"
        class="connection-modal__row connection-modal__row--phone"
      >
        <i-button
          v-for="b in row"
          :key="b.key"
          :loading="is_loading(is_button_loading, b.key)"
          :disabled="is_disabled(b.key)"
          v-bind="base_button_props"
          @click="set_value(b.key)"
        >
          {{ b.label }}
        </i-button>
      </div>
    </template>
  </base-modal>
</template>

<script>
  import BaseModal from '../_base';

  export default {
    components: { BaseModal },
    props: {
      box: {
        type: Object,
        require: true,
        default: () => ({})
      }
    },

    data() {
      return {
        current_value: '',
        base_button_props: {
          ghost: true,
          long: true,
          size: 'large',
          type: 'primary'
        },

        rows: [
          [
            {
              key: 'key_1',
              label: 1
            },

            {
              key: 'key_2',
              label: 2
            },

            {
              key: 'key_3',
              label: 3
            }
          ],

          [
            {
              key: 'key_4',
              label: 4
            },

            {
              key: 'key_5',
              label: 5
            },

            {
              key: 'key_6',
              label: 6
            }
          ],

          [
            {
              key: 'key_7',
              label: 7
            },

            {
              key: 'key_8',
              label: 8
            },

            {
              key: 'key_9',
              label: 9
            }
          ],

          [
            {
              key: 'key_0',
              label: 0
            },

            {
              key: 'timeout',
              label: 'timeout'
            }
          ]
        ]
      };
    },

    methods: {
      is_disabled: function(type) {
        const free_options = Object.keys(this.box.getFreeOptions());
        return !free_options.includes(type);
      },

      is_loading: function(is_button_loading, type) {
        return is_button_loading && type === this.current_value;
      },

      set_value: function(value) {
        this.current_value = value;
        this.$emit('confirm', this.current_value);
      }
    }
  };
</script>
